/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Checkinflyermotif2Inputs */

const en_checkinflyermotif2 = /** @type {(inputs: Checkinflyermotif2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Design`)
};

const de_checkinflyermotif2 = /** @type {(inputs: Checkinflyermotif2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Motiv`)
};

/**
* | output |
* | --- |
* | "Design" |
*
* @param {Checkinflyermotif2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const checkinflyermotif2 = /** @type {((inputs?: Checkinflyermotif2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Checkinflyermotif2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_checkinflyermotif2(inputs)
	return de_checkinflyermotif2(inputs)
});
export { checkinflyermotif2 as "checkinFlyerMotif" }